// extracted by mini-css-extract-plugin
export default {"assignee__card":"MemberCard_assignee__card__zgWYE","assignee__card_border":"MemberCard_assignee__card_border__P1++m"};